import React from "react";
import goalsIomage from "../images/afro-solar/the-bettery-energy/golas.webp";
import image_1 from "../images/afro-solar/the-bettery-energy/side-image.webp";
import unEnergyImage from "../images/afro-solar/the-bettery-energy/un-energy.webp";
import unitedNationsImage from "../images/afro-solar/the-bettery-energy/united-nations.webp";

const TheBetterEnergyChoice = () => {
  return (
    <div className="container-fluid better-energy-choice">
      <div className="me-13 ms-13 pt-13">
        <div className="row text-center">
          <div className="col-12 col-md-12 col-lg-6 col-xl-6 p-5 bg-white order-1 order-lg-0">
            <div className="d-flex justify-content-around mb-4 mt-5">
              <img
                src={unitedNationsImage}
                loading="lazy"
                alt="United Nations"
                className="img-fluid card-design-2"
                style={{ height: "60px" }}
              />
              <img
                src={unEnergyImage}
                loading="lazy"
                alt="UN Energy"
                className="img-fluid card-design-2"
                style={{ height: "60px" }}
              />
            </div>
            <h2 className="fs-32 gilroy-bold py-5">
              The Better Energy Choice <br className="d-none d-md-block" /> for
              the Planet
            </h2>
            <p className="fs-16 lh-30 text-align-justify">
              The Paris Agreement is a legally binding international treaty on
              climate change that mandates National and city governments,
              foundations and businesses to make commitments and partnerships
              for clean electricity access and cooking solutions. Actions
              defined in an Energy Compact can also contribute to Nationally
              Determined Contributions under the Paris Agreement on climate
              change and achievement of the broader 2030 Agenda and the
              Sustainable Development Goals.
            </p>
            <img
              src={goalsIomage}
              loading="lazy"
              alt="goals"
              className="img-fluid d-block mx-auto my-5 card-design-2"
              style={{ height: "60px" }}
            />
          </div>
          <div className="col-12 col-md-12 col-lg-6 col-xl-6 order-0 order-lg-1 my-auto">
            <img
              src={image_1}
              loading="lazy"
              className="img-fluid rounded"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TheBetterEnergyChoice;
